import { TargetConfig } from "../../types/TargetConfig";
import targetsConfigs from "../targetsConfigs.json";

export const getTargetConfig = (targetId: string): TargetConfig => {
    const data = targetsConfigs.find(entry => entry.targetId == targetId);

    if (!data) {
        throw new Error(`Target config not found for ID: ${targetId}`);
    }
    
    return data as TargetConfig;
};